import { render } from "./Signin.vue?vue&type=template&id=50f7f35d"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=50f7f35d&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__